import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/coachSystem';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-ink py-11 sm:py-14" aria-labelledby="faq-title" data-id="element-34" data-mp="1bmvbwt4ic0p4">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-3xl" data-id="element-35" data-mp="1gjvjx9kx3div">
        <span className="mx-auto mb-4 block h-[2px] w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-36" data-mp="24ahga3lk79d1" />
        <h2 id="faq-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight tracking-tight text-ivory sm:text-[2rem]" data-id="element-37" data-mp="28cvxkj9ky127">
          Frequently asked questions
        </h2>

        <ul className="mt-5 divide-y divide-char-line border-y border-char-line" data-id="element-38" data-mp="2n7imtsurhhj3">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-39" data-mp="14v0t8v9xhs6p" data-mpi={index}>
                <h3 data-id="element-40" data-mp="14w3m38qta4p9">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-4 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange" data-id="element-41" data-mp="14vk45s15vgb8">
                    <span className="text-[0.95rem] font-semibold leading-snug text-ivory" data-id="element-42" data-mp="1jkzp2re0grj0">
                      {faq.question}
                    </span>
                    <PlusIcon className={`mt-0.5 h-4 w-4 shrink-0 text-orange transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-43" data-mp="1xhv9ffzpq5ed" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-44" data-mp="1y9mpt5pe88b6">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-45" data-mp="2386evezaa07r">
                      <p className="pb-4 pr-6 text-[0.9rem] leading-relaxed text-ivory-muted" data-id="element-46" data-mp="2m6sesqj2dla3">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}